import { useState } from "react"
import { AlertCircle, X } from "lucide-react"
import { Button } from "./ui/button"

export function ModelErrorMessage({ message }: { message: string }) {
  const [isDismissed, setIsDismissed] = useState(false)

  if (isDismissed) return null

  return (
    <div className="absolute top-4 left-1/2 -translate-x-1/2 z-50 max-w-md animate-in slide-in-from-top duration-300">
      <div className="bg-red-50 border border-red-200 rounded-lg p-4 shadow-lg">
        <div className="flex items-start gap-3">
          <AlertCircle className="h-5 w-5 text-red-600 flex-shrink-0 mt-0.5" />
          <div className="flex-1">
            <h3 className="text-sm font-semibold text-red-900">Model Loading Error</h3>
            <p className="text-sm text-red-700 mt-1">{message}</p>
            <p className="text-xs text-red-600 mt-2">
              Check the browser console for more details.
            </p>
          </div>
          <Button
            variant="ghost"
            size="icon"
            className="h-6 w-6 text-red-600 hover:text-red-800 hover:bg-red-100"
            onClick={() => setIsDismissed(true)}
          >
            <X className="h-4 w-4" />
          </Button>
        </div>
      </div>
    </div>
  )
}
